import { Component, computed, HostBinding, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MenuService } from '@app/core/api/menu.service';
import { GlobalSideNavService } from '@app/core/services/global-side-nav.service';
import { UserState } from '@app/core/store/states/user/user.state';
import { TourModule } from '@app/shared/modules/tour/tour.module';
import { select } from '@ngxs/store';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzSiderComponent } from 'ng-zorro-antd/layout';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { filter, map } from 'rxjs/operators';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'adspt-global-side-nav',
  templateUrl: './global-side-nav.component.html',
  styleUrls: ['./global-side-nav.component.scss'],
  imports: [
    TourModule,
    NzDropDownModule,
    IconComponent,
    NzSwitchModule,
    FormsModule,
    NzSiderComponent,
    RouterLinkActive,
    RouterLink,
  ],
})
export class GlobalSideNavComponent {
  private router = inject(Router);
  readonly ms = inject(MenuService);
  private route = inject(ActivatedRoute);
  readonly ss = inject(GlobalSideNavService);

  readonly disableLinks = input(true);
  readonly user = select(UserState.user);
  readonly isSysAdminOnly = computed(() => !!this.user()?.sysAdmin);

  @HostBinding('class.is-open') get sidebarState() {
    return this.ss.isOpen();
  }

  closeSider() {
    this.ss.close();
  }
  openSider() {
    this.ss.open();
  }

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route),
      )
      .subscribe(() => this.closeSider());
  }
}
